var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1666.197,
    height: 1171.837,
    viewBox: "0 0 1666.197 1171.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "loading",
    transform: "translate(-177.369 -4724.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    d: "M1361.367,1177.549c209.991-204.2,220.738-517.33-158.32-868.486-54.978-51.051-81.847-122.15-136.411-160.387-165.347-115.95-397.453-92.388-543.579,79.78C443.07,322.7,410.827,452.088,327.74,544.476,234.526,648.231,122.916,749.093,80.546,890.465c-28.109,93.628-23.355,195.73,8.681,287.291C549.719,1259.6,985,1284.818,1361.367,1177.549Z",
    transform: "translate(261.44 4647.072)",
    fill: "#c2b59c",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435",
    transform: "translate(-433.725 -1667.189) rotate(43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M2961.923-628.7l25.85,40.357,59.97-33.327L3026.911-670.4Z",
    transform: "translate(2901.784 4095.506)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M2961.923-628.7l25.85,40.357,59.97-33.327L3026.911-670.4Z",
    transform: "translate(2901.784 4095.506)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    d: "M3065.874-622.7c132.882-71.576,291.674-27.48,366.312,103.721,86.17,151.459,18.146,308.958-115.116,380.055-133.139,71.065-287.17,8.148-358.771-124.746C2886.7-396.538,2933.023-551.1,3065.874-622.7Z",
    transform: "translate(2849.88 4114.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    d: "M3062.686-618.192c132.881-71.608,280.811-35.436,355.447,95.765,86.169,151.459,22.2,317.139-115.118,380.055-82.814,37.961-264.068,10.481-337.811-128.293C2906.415-381.256,2929.836-546.584,3062.686-618.192Z",
    transform: "translate(2863.933 4117.91)",
    fill: "#a49474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1670",
    "data-name": "Path 1670",
    d: "M3185.731-97.093a267.987,267.987,0,0,1-44.764-7.893,275.279,275.279,0,0,1-41.151-14.73c-6.55-2.844-12.812-6.167-19.042-9.362-6.071-3.483-12.142-6.838-17.859-10.641a285.682,285.682,0,0,1-32.431-23.965c-5.112-4.186-9.776-8.755-14.569-13.1-4.5-4.6-9.17-8.979-13.322-13.74a330.313,330.313,0,0,1-23.516-28.726,330.8,330.8,0,0,1-34.539-60.36,278.779,278.779,0,0,1-23.291-118.675,259.039,259.039,0,0,1,21.375-96.116,242.622,242.622,0,0,1,19.33-36.267c3.322-5.5,7.092-10.385,10.479-15.274,3.738-4.6,7.094-9.267,10.8-13.325a236.6,236.6,0,0,1,40.641-37.481c24.538-17.51,40.929-22.367,47-20.961,2.141.575-1.854,4.218-10.928,10.768-8.913,6.775-22.78,16.84-38.915,32.05a271.031,271.031,0,0,0-49.683,63.459,249.2,249.2,0,0,0-31.12,101.26,256.844,256.844,0,0,0,2.524,61.606,267.579,267.579,0,0,0,19.073,63.907,300.423,300.423,0,0,0,89.015,114.9,257.893,257.893,0,0,0,32.206,21.7c5.59,3.355,11.5,6.231,17.38,9.235,6.007,2.716,12.014,5.5,18.245,7.829a248.032,248.032,0,0,0,38.435,11.5,246.117,246.117,0,0,0,40.354,4.985,222.215,222.215,0,0,0,41.12-2.173,229.752,229.752,0,0,0,40.544-9.49,263.4,263.4,0,0,0,38.788-16.616,326.938,326.938,0,0,0,36.232-22.815c46.326-33.775,80.706-79.916,97.863-129.475a248.015,248.015,0,0,0,9.872-37.513,240.248,240.248,0,0,0,3.739-37.641,238.024,238.024,0,0,0-2.013-36.778,259.5,259.5,0,0,0-7.062-35.213,294.309,294.309,0,0,0-26.327-63.588,268.449,268.449,0,0,0-37.445-52.212,257.76,257.76,0,0,0-92.879-65.026,263.317,263.317,0,0,0-91.282-19.4c-27.731-.958-51.665,2.62-71.154,6.71-19.521,4.218-34.666,9.363-45.594,12.941q-4.167,1.294-7.475,2.3c-2.2.735-4.154,1.31-5.881,1.758-3.417.863-5.814,1.15-7.188.8-1.054-.288-.159-1.5,2.621-3.643a100.244,100.244,0,0,1,13.9-8.787,243.1,243.1,0,0,1,62.336-23.1,256.375,256.375,0,0,1,48.053-6.359,262.459,262.459,0,0,1,57.287,3.9A270.574,270.574,0,0,1,3318-636.788a271.332,271.332,0,0,1,61.506,38.025c4.984,3.866,9.584,8.307,14.409,12.558,4.536,4.569,9.329,8.947,13.643,13.9a278.224,278.224,0,0,1,24.952,31.091,311.84,311.84,0,0,1,37.671,73.972c2.555,6.646,4.376,13.612,6.452,20.514.928,3.515,1.727,7.03,2.558,10.577.927,3.515,1.6,7.093,2.235,10.7a254.657,254.657,0,0,1,4.538,44c.288,7.477-.128,14.954-.447,22.463-.673,7.509-1.279,15.018-2.526,22.5a265.608,265.608,0,0,1-10.8,44.383c-19.618,58.188-60,109.729-111.092,145.1a315.853,315.853,0,0,1-40.064,23.805,250.2,250.2,0,0,1-43.486,17.063A248.094,248.094,0,0,1,3185.731-97.093Z",
    transform: "translate(2844.82 4109.953)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1672",
    "data-name": "Path 1672",
    d: "M3179.3-200.006c-120.356,6.391-220.011-79.66-229.18-199.9-10.577-138.774,92.3-229.33,212.79-235.21,120.42-5.911,210.2,92.09,216.559,212.491C3385.86-302.225,3299.69-206.4,3179.3-200.006Z",
    transform: "translate(2884.255 4144.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1674",
    "data-name": "Path 1674",
    d: "M3174.745-211.176c-130.709-3.387-218.764-128.741-216.272-208.752,4.345-139.126,92.018-202.521,212.5-208.784,96.266-4.985,189.5,76.689,195.857,197.089C3373.221-311.222,3295.263-208.013,3174.745-211.176Z",
    transform: "translate(2896.896 4153.418)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1676",
    "data-name": "Path 1676",
    d: "M3281.074-611.542a215.927,215.927,0,0,1,29.842,21.186,223.209,223.209,0,0,1,24.857,24.924c3.77,4.313,7.188,8.883,10.607,13.356,3.227,4.633,6.485,9.139,9.329,13.868a229.576,229.576,0,0,1,15.336,28.6,256.212,256.212,0,0,1,18.309,58,266.942,266.942,0,0,1,4.409,55.727,224.886,224.886,0,0,1-23.708,94.455,208.492,208.492,0,0,1-48.563,62.725,194.112,194.112,0,0,1-26.552,19.779c-4.313,2.876-8.754,5.112-12.907,7.509-4.281,2.077-8.339,4.282-12.461,5.975a183.121,183.121,0,0,1-42.525,13.1c-23.931,4.026-37.541,1.406-41.472-2.588-1.375-1.438,2.746-2.972,11.47-4.793,8.69-2.077,22.046-4.793,38.756-10.353a219.268,219.268,0,0,0,56.936-28.982,198.977,198.977,0,0,0,56.36-62.053,206.714,206.714,0,0,0,18.979-44.927,212.016,212.016,0,0,0,7.892-52.18,237.87,237.87,0,0,0-24.856-112.445c-18.149-36.2-47.639-69.243-86.2-89.086a183.433,183.433,0,0,0-62.3-19.268,207.028,207.028,0,0,0-33.356-1.214,256,256,0,0,0-33.707,4.058c-44.635,8.532-84.829,29.972-113.839,59.625a193.664,193.664,0,0,0-35.051,49.176,186.231,186.231,0,0,0-10.958,27,203.84,203.84,0,0,0-6.806,27.544,232.479,232.479,0,0,0-2.619,54.417,214.215,214.215,0,0,0,9.168,50.039,204.3,204.3,0,0,0,44.443,77.807,209.241,209.241,0,0,0,58.662,44.831,237.954,237.954,0,0,0,53.1,19.619c15.4,3.739,27.988,5.368,37.062,6.774,4.538.8,8.212,1.374,10.991,2.045,2.748.7,4.6,1.5,5.464,2.4.7.7-.384,1.438-3.1,2.141a70.644,70.644,0,0,1-13.067,1.981,188.315,188.315,0,0,1-53.2-4.026,204.309,204.309,0,0,1-37.222-11.663,208.807,208.807,0,0,1-40.386-22.367,215.23,215.23,0,0,1-39.042-35.341A217.711,217.711,0,0,1,2967.322-313c-2.333-4.537-4.154-9.331-6.2-14.091-1.725-4.889-3.738-9.714-5.176-14.795a221.524,221.524,0,0,1-7.508-31.25,248.916,248.916,0,0,1-2.045-66.847c.415-5.719,1.5-11.407,2.332-17.191,1.213-5.687,2.205-11.471,3.866-17.127a201.066,201.066,0,0,1,11.854-33.679c2.363-5.528,5.239-10.864,8.052-16.232,3.067-5.24,6.1-10.513,9.616-15.529a212.559,212.559,0,0,1,23.165-28.631c34.346-35.692,81.536-59.273,130.9-67.39a247.44,247.44,0,0,1,37.349-3.483,202.133,202.133,0,0,1,37.542,2.556A200.935,200.935,0,0,1,3281.074-611.542Z",
    transform: "translate(2878.204 4138.933)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1678",
    "data-name": "Path 1678",
    d: "M2989.851-629.346c7.7,19.4,23.132,19.939,8.435,30.2-9.969,6.966-17.062-10.161-27.894-27.321s-23.451-26.17-11.245-34.7C2968.665-667.85,2982.182-648.551,2989.851-629.346Z",
    transform: "translate(2890.918 4106.506)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1680",
    "data-name": "Path 1680",
    d: "M3015.206-641.119c7.094,21.92,22.876,24.572,7.412,33.647-10.512,6.135-17.027-13.229-27.412-33.136-10.353-19.939-22.91-31.315-10.1-38.888C2995.141-685.406,3008.178-662.815,3015.206-641.119Z",
    transform: "translate(2926.588 4081.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1682",
    "data-name": "Path 1682",
    d: "M3043.1-592.98c-46.232,26.713-94.188,30.2-107.129,7.765-12.94-22.4,14.058-62.214,60.289-88.895,46.232-26.713,94.189-30.2,107.128-7.765C3116.331-659.475,3089.335-619.661,3043.1-592.98Z",
    transform: "translate(2861.023 4058.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1698",
    "data-name": "Path 1698",
    d: "M2984.37-538.588a8.7,8.7,0,0,1-8.69,8.692,8.7,8.7,0,0,1-8.69-8.692,8.679,8.679,0,0,1,8.69-8.691A8.679,8.679,0,0,1,2984.37-538.588Z",
    transform: "translate(2908.858 4267.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1700",
    "data-name": "Path 1700",
    d: "M2992.961-573.729a8.7,8.7,0,0,1-8.69,8.692,8.708,8.708,0,0,1-8.723-8.692,8.715,8.715,0,0,1,8.723-8.723A8.707,8.707,0,0,1,2992.961-573.729Z",
    transform: "translate(2920.813 4218.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1702",
    "data-name": "Path 1702",
    d: "M3059.155-617.88a8.679,8.679,0,0,1-8.69,8.692,8.688,8.688,0,0,1-8.723-8.692,8.708,8.708,0,0,1,8.723-8.691A8.7,8.7,0,0,1,3059.155-617.88Z",
    transform: "translate(3013.251 4156.709)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1704",
    "data-name": "Path 1704",
    d: "M3093.232-603.974a8.708,8.708,0,0,1-8.691,8.724,8.714,8.714,0,0,1-8.723-8.724,8.706,8.706,0,0,1,8.723-8.691A8.7,8.7,0,0,1,3093.232-603.974Z",
    transform: "translate(3060.841 4176.132)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    "data-name": "Path 1706",
    d: "M3124.88-540.334a8.713,8.713,0,0,1-8.722,8.723,8.706,8.706,0,0,1-8.689-8.723,8.7,8.7,0,0,1,8.689-8.691A8.706,8.706,0,0,1,3124.88-540.334Z",
    transform: "translate(3105.039 4265.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    d: "M3120.361-507.988a8.686,8.686,0,0,1-8.722,8.692,8.68,8.68,0,0,1-8.69-8.692,8.7,8.7,0,0,1,8.69-8.691A8.706,8.706,0,0,1,3120.361-507.988Z",
    transform: "translate(3098.729 4310.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    d: "M3060.176-464.174a8.706,8.706,0,0,1-8.69,8.723,8.708,8.708,0,0,1-8.69-8.723,8.7,8.7,0,0,1,8.69-8.691A8.7,8.7,0,0,1,3060.176-464.174Z",
    transform: "translate(3014.724 4371.363)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    d: "M3019.866-475.294a8.707,8.707,0,0,1-8.723,8.691,8.7,8.7,0,0,1-8.691-8.691,8.681,8.681,0,0,1,8.691-8.691A8.687,8.687,0,0,1,3019.866-475.294Z",
    transform: "translate(2958.385 4355.836)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    d: "M3024.52-601.61c5.464,11.152,16.136,9.011,6.07,17.926-6.836,6.039-11.853-3.738-19.456-12.973-7.6-9.2-16.359-12.941-8.052-20.354C3009.631-622.827,3019.089-612.667,3024.52-601.61Z",
    transform: "translate(2954.559 4167.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    d: "M3089.034-475.091c-4.889-11.407-15.623-9.874-5.112-18.245,7.125-5.656,11.63,4.378,18.724,14,7.092,9.586,15.688,13.8,6.965,20.738C3102.772-453.139,3093.857-463.78,3089.034-475.091Z",
    transform: "translate(3065.932 4340.484)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    d: "M3112.8-563.465c-11.789,3.866-11.183,14.7-18.595,3.515-5.048-7.6,5.368-11.216,15.527-17.447,10.193-6.263,15.113-14.443,21.313-5.145C3135.872-575.256,3124.5-567.3,3112.8-563.465Z",
    transform: "translate(3084.688 4212.343)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    d: "M2992.492-510.1c12.172-2.46,12.811-13.293,18.881-1.31,4.122,8.148-6.646,10.513-17.477,15.53-10.863,5.017-16.709,12.558-21.758,2.588C2968.177-501.06,2980.415-507.642,2992.492-510.1Z",
    transform: "translate(2914.989 4309.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M3166.761-400.049a223.3,223.3,0,0,0,65.53-15.721,271.053,271.053,0,0,0,41.663-21.409c20.927-13.261,30.416-20.93,35.049-18.565,2.875,1.118-13.706,17.99-46.423,35.82a262.348,262.348,0,0,1-60.323,23.07,272.158,272.158,0,0,1-37.029,6.071,263.576,263.576,0,0,1-39.587.287,238.07,238.07,0,0,1-38.276-5.784,236.736,236.736,0,0,1-33.771-10.449,225.3,225.3,0,0,1-51.28-28.151c-13.291-9.842-22.652-19.4-28.5-26.713a49.359,49.359,0,0,1-6.23-9.139c-1.247-2.429-1.693-4.09-1.279-5.049.353-.735,1.885.1,4.442,2.173,1.277,1.054,2.779,2.428,4.567,4.058,1.822,1.6,3.931,3.451,6.231,5.56,4.7,4.186,10.512,9.107,17.381,14.475a262.153,262.153,0,0,0,24.122,16.3,251.335,251.335,0,0,0,30.354,15.338,249.3,249.3,0,0,0,35.465,11.663A242.416,242.416,0,0,0,3166.761-400.049Z",
    transform: "translate(2907.691 4366.927)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    transform: "translate(8.038 -7.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1688",
    "data-name": "Path 1688",
    d: "M3026.02-387.582l83.454-142.385s-79.461-21.824-84-13.868C3020.939-535.847,3032.983-448.805,3026.02-387.582Z",
    transform: "translate(2989.068 4269.816)",
    fill: "#007f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1690",
    "data-name": "Path 1690",
    d: "M3098.117-602.225c-8.53,40.8-34.729,87.01-74.987,137.5h0l87.479,22.879C3109.811-504.383,3106.681-555.765,3098.117-602.225Z",
    transform: "translate(2987.263 4190.709)",
    fill: "#fdbe30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1692",
    "data-name": "Path 1692",
    d: "M3033.049-437.169c3.674,91.994,19.553,129.891,2.013,135-5.815,1.662-9.618-16.935-12.878-47-1.6-15.018-3.1-32.912-4.6-52.531-1.6-20.642-3.322-43.105-5.079-66.24,1.757-2.684,3.513-5.4,5.271-8.116,49.619-76.241,79.812-133.406,94-127.974,4.983,1.917-3.61,20.77-19.331,47.706-7.892,13.484-17.54,28.95-28.18,45.342-5.3,8.18-10.9,16.584-16.613,25.083-2.845,4.25-5.752,8.531-8.66,12.813h0l-4.408,6.423-2.2,3.2c-.257.384-.16.224-.191.288h0l-.065.032-.158.127a1.012,1.012,0,0,0-.066.384h0l.161,3.675.352,7.285C3032.632-446.787,3032.823-441.962,3033.049-437.169Z",
    transform: "translate(2972.421 4187.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1694",
    "data-name": "Path 1694",
    d: "M3100.63-417.535c-23.515,36.076-37.573,63.268-47.7,80.874-10.161,17.542-16.454,25.371-24.985,22.144-5.783-2.173,1.981-19.108,16.614-44.607,7.316-12.749,16.327-27.608,26.2-43.872,4.889-8.148,10-16.616,15.24-25.339,2.588-4.346,5.207-8.788,7.73-13.229.641-1.119,1.216-2.205,1.822-3.292h0l.863-1.629c.256-.448.735-1.31.7-1.278.032-.064.063-.16.1-.224h0l.1-.1.063-.032v-.032h.032c-.255-.1.735.192,1.055.256,1.918.511,3.835.958,5.751,1.374.639.16,1.055.224.224,0h0l-1.406-.383-2.78-.735-2.811-.671-.032-.032v-.063c-.032-.064-.032-.16-.063-.224a.553.553,0,0,1,.031-.223v-.831h0l-.031-1.885c-.161-10.129-.831-20.45-1.438-30.133-.7-9.713-1.374-18.98-2.014-27.735-1.34-17.542-2.587-33.04-3.226-46.013-1.278-25.946-.128-41.795,7.188-43.776,5.72-1.565,10.577,22.208,14.027,57.037,1.725,17.415,3.131,37.577,3.994,58.794.415,10.673.767,21.313.639,32.72h0l-.064,2.237c-.062,1.214-.191,2.428-.351,3.611a10.707,10.707,0,0,1-1.087,3.419h0l-.733,1.63-.385.767-.256.479c-1.437,2.492-2.876,4.985-4.313,7.285C3106.444-426.546,3103.538-422.04,3100.63-417.535Z",
    transform: "translate(2991.3 4194.801)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1696",
    "data-name": "Path 1696",
    d: "M3085.683-523.277a29.748,29.748,0,0,1-29.746,29.717,29.72,29.72,0,0,1-29.713-29.717,29.727,29.727,0,0,1,29.713-29.749A29.754,29.754,0,0,1,3085.683-523.277Z",
    transform: "translate(2991.581 4259.421)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    d: "M3072.788-536.026c23.418,8.947,36.039,2.333,33.675,15.561-1.63,9.011-22.492,1.214-46.327-4.889-23.866-6.1-41.855-6.167-39.907-17.191C3021.731-551.14,3049.623-544.877,3072.788-536.026Z",
    transform: "translate(2983.006 4268.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M3046.773-548.96c7.381-.32,12.238,3.163,14.348,5.72a6.269,6.269,0,0,1,1.82,3.355,2.019,2.019,0,0,1-1.182,2.173c-.639.384-1.437.064-2.3-.7-.447-.384-.8-.959-1.375-1.47s-1.182-1.118-1.82-1.758c-1.5-1.022-3.227-2.4-5.559-2.684a13.08,13.08,0,0,0-7.444.927,13.721,13.721,0,0,0-5.527,4.793c-.288.479-.544.927-.8,1.374a14.366,14.366,0,0,0-.513,1.342,11.741,11.741,0,0,0-.638,2.46c-.384,3.036.031,5.049-1.791,5.975-.639.351-1.405-.288-2.235-1.885a11.6,11.6,0,0,1-.543-7.222,16.692,16.692,0,0,1,5.5-8.436A17,17,0,0,1,3046.773-548.96Z",
    transform: "translate(2998.124 4265.069)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437",
    transform: "translate(81 -29)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_225",
    "data-name": "Ellipse 225",
    cx: 36,
    cy: 7.1,
    rx: 36,
    ry: 7.1,
    transform: "translate(1000.425 5325.979) rotate(5)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_226",
    "data-name": "Ellipse 226",
    cx: 16.754,
    cy: 7.1,
    rx: 16.754,
    ry: 7.1,
    transform: "translate(938.25 5331.555) rotate(-18)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_227",
    "data-name": "Ellipse 227",
    cx: 36,
    cy: 7.1,
    rx: 36,
    ry: 7.1,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 855.133, 5364.611)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_228",
    "data-name": "Ellipse 228",
    cx: 16.754,
    cy: 7.1,
    rx: 16.754,
    ry: 7.1,
    transform: "translate(811.288 5395.25) rotate(-38)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_229",
    "data-name": "Ellipse 229",
    cx: 16.754,
    cy: 7.1,
    rx: 16.754,
    ry: 7.1,
    transform: "matrix(0.695, -0.719, 0.719, 0.695, 777.958, 5430.563)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_230",
    "data-name": "Ellipse 230",
    cx: 36,
    cy: 7.1,
    rx: 36,
    ry: 7.1,
    transform: "translate(733.521 5503.656) rotate(-54)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_231",
    "data-name": "Ellipse 231",
    cx: 16.754,
    cy: 7.1,
    rx: 16.754,
    ry: 7.1,
    transform: "matrix(0.695, -0.719, 0.719, 0.695, 709.4, 5541.09)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_232",
    "data-name": "Ellipse 232",
    cx: 36,
    cy: 7.1,
    rx: 36,
    ry: 7.1,
    transform: "matrix(0.799, -0.602, 0.602, 0.799, 653.351, 5597.826)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_233",
    "data-name": "Ellipse 233",
    cx: 16.754,
    cy: 7.1,
    rx: 16.754,
    ry: 7.1,
    transform: "translate(609.007 5620.414) rotate(-24)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_234",
    "data-name": "Ellipse 234",
    cx: 16.754,
    cy: 7.1,
    rx: 16.754,
    ry: 7.1,
    transform: "translate(558.521 5622.621) rotate(-5)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_235",
    "data-name": "Ellipse 235",
    cx: 16.754,
    cy: 7.1,
    rx: 16.754,
    ry: 7.1,
    transform: "translate(521.674 5613.938) rotate(15)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438",
    transform: "matrix(0.574, 0.819, -0.819, 0.574, 219.841, 4407.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    d: "M1063.883,228.2a7.21,7.21,0,0,1,9.341-4.088l187.426,73.32a7.211,7.211,0,0,1,4.089,9.342L1145.792,610.834a7.21,7.21,0,0,1-9.341,4.089L949.025,541.6a7.211,7.211,0,0,1-4.088-9.343Z",
    transform: "translate(-148.254 -6.077)",
    fill: "#c2b59c",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    d: "M2134.7,676.05a20.544,20.544,0,1,0-11.648-26.616A20.543,20.543,0,0,0,2134.7,676.05Zm-1.052,2.686a23.428,23.428,0,1,0-13.282-30.353A23.428,23.428,0,0,0,2133.644,678.736Z",
    transform: "translate(-1097.263 -337.308)",
    fill: "#998b71",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    "data-name": "Path 2469",
    d: "M1260.873,297.216c22.137,6.533,42.719,11.55,42.719,11.55l-124.2,317.489-42.132-16.482S1219.29,372.467,1260.873,297.216Z",
    transform: "translate(-304.081 -61.57)",
    fill: "#998b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    "data-name": "Path 2470",
    d: "M1.634,138.259c-1.54-.124,1.733-31.074,1.989-69.265C3.873,30.982.96.434,2.362.025c1.247-.4,6.478,30.062,6.211,68.612-.112,38.545-5.708,69.758-6.939,69.623Z",
    transform: "translate(863.462 562.037) rotate(-67)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2471",
    "data-name": "Path 2471",
    d: "M338.658,45.718c-.3.011-.88-6.063-1.455-17.156-.217-2.86-.276-5.905-.477-9.3s-.08-7.347-1.375-9.809c-1.441-2.636-4.776-3.053-8.437-2.74-3.819.5-7.791,1-12.067,1.515-33.916,4.463-80.921,9.045-132.854,10.58A1314.146,1314.146,0,0,1,49.539,16.283Q36.784,15.4,26.772,14.424c-6.523-.659-12.322-.089-16.789,1.688a16.349,16.349,0,0,0-5.425,3.245A10.826,10.826,0,0,0,1.7,23.225,25.557,25.557,0,0,0,.694,26.31,6.879,6.879,0,0,1,.356,27.4a3.5,3.5,0,0,1-.114-1.251A19.148,19.148,0,0,1,.8,22.72a13.611,13.611,0,0,1,2.884-4.766,18.485,18.485,0,0,1,5.9-3.98,36.516,36.516,0,0,1,17.584-2.792c6.686.294,14.281.734,22.795.962,33.74,1.28,80.423,2.267,132.2.737s98.612-5.388,132.495-8.774c4.271-.335,8.395-.844,12.208-1.162a16.536,16.536,0,0,1,5.919.5,8.537,8.537,0,0,1,4.9,3.944,15.845,15.845,0,0,1,1.337,6.046c.092,1.968.043,3.584.14,5.373.048,3.4.108,6.449.02,9.321-.04,11.295-.226,17.4-.537,17.587Z",
    transform: "translate(775.238 530.736) rotate(-67)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2472",
    "data-name": "Path 2472",
    d: "M336.14,2.922c.154-.006.413,1.6.623,4.818s.528,7.868.648,13.959a362.9,362.9,0,0,1-2.681,51.723c-.63,5.4-1.426,11.165-2.382,17.115a60.809,60.809,0,0,1-1.988,9.393,14.534,14.534,0,0,1-2.777,4.94,11.35,11.35,0,0,1-4.41,2.847c-3.124,1.188-5.75,1.282-8.548,1.921-2.792.459-5.745,1.1-8.7,1.747-5.9,1.108-11.8,2.217-18.007,3.336-24.673,4.293-51.962,8.321-80.453,11.317a1199.783,1199.783,0,0,1-146.214,6.689c-18.663-.4-33.766-1.117-44.085-1.821-10.314-.884-16.163-1.391-16-1.755.011-.359,5.883-.57,16.218-.4,10.5-.019,25.461.16,44.141.027,37.364-.447,88.972-2.3,145.96-8.472,28.492-3,55.62-6.839,80.282-10.773,6.2-.94,12.1-1.869,18-2.977,2.947-.464,5.745-1.1,8.692-1.567a53.027,53.027,0,0,0,8.079-1.724,7.351,7.351,0,0,0,4.62-4.648,63.451,63.451,0,0,0,1.806-8.49c1.1-5.776,1.9-11.361,2.68-16.767a471.193,471.193,0,0,0,4.209-51.24c-.075-12.545-.178-19.174.285-19.191Z",
    transform: "translate(884.247 561.807) rotate(-67)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2473",
    "data-name": "Path 2473",
    d: "M1837.385-1488.278c52.282,5.343,105.857,3.734,158.379,4.788,49.9,1.016,101.9,8.522,151.594,4.307,8.67-.739,7.8-13.736-.333-14.863-51.524-7.136-106.43-2.108-158.471-3.808-50.229-1.627-101.235-5.657-151.446-3.217C1829.732-1500.7,1830.3-1489,1837.385-1488.278Z",
    transform: "translate(1634.109 2781.711) rotate(-70)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    d: "M977.813-1411.941c4.646-.6,8.994-1.217,13.629.387a21.376,21.376,0,0,1,11.384,9.31c2.032,5.391,1.286,2.051,2,5.857,1.184,8.825-4.755,18.307-13.323,21.055-11.309,3.625-24.133-5.13-25.526-16.772C964.909-1401,970.437-1408.161,977.813-1411.941Zm-3.308,40.2c19.576,11.749,41.268-9.723,36.274-29.058.682-3.754-3.016-6.855-3.375-7.379-6.342-9.259-23.312-15.727-32.752-7.513a2.2,2.2,0,0,0-.756,1.35,26.092,26.092,0,0,0-11.335,13.477C958.462-1389.441,964.544-1377.722,974.5-1371.745Z",
    transform: "matrix(0.574, -0.819, 0.819, 0.574, 1621.888, 1925.851)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    d: "M2117.976,783.1a23.428,23.428,0,1,1-13.284-30.353A23.428,23.428,0,0,1,2117.976,783.1Z",
    transform: "translate(-1060.071 -432.38)",
    fill: "#998b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2474",
    "data-name": "Path 2474",
    d: "M976.971-1412.323c4.41-.572,8.537-1.155,12.936.367a20.289,20.289,0,0,1,10.8,8.837c1.928,5.117,1.221,1.947,1.9,5.559a19.139,19.139,0,0,1-12.646,19.984c-10.734,3.441-22.906-4.87-24.228-15.919C964.724-1401.939,969.971-1408.735,976.971-1412.323Zm-3.14,38.152c18.58,11.151,39.17-9.229,34.43-27.581.647-3.563-2.862-6.506-3.2-7-6.02-8.788-22.127-14.927-31.087-7.131a2.086,2.086,0,0,0-.717,1.282,24.765,24.765,0,0,0-10.759,12.792C958.6-1390.967,964.377-1379.844,973.832-1374.17Z",
    transform: "matrix(0.574, -0.819, 0.819, 0.574, 1613.954, 1949.402)",
    fill: "#231f1f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderClock);
export default __webpack_public_path__ + "static/media/loaderClock.974ef093b35fa342154e40358f4d4361.svg";
export { ForwardRef as ReactComponent };